import { render } from "./LicenseCreateComponent.vue?vue&type=template&id=7089a1d4&scoped=true"
import script from "./LicenseCreateComponent.vue?vue&type=script&lang=js"
export * from "./LicenseCreateComponent.vue?vue&type=script&lang=js"

import "./LicenseCreateComponent.vue?vue&type=style&index=0&id=7089a1d4&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7089a1d4"]])

export default __exports__